import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { AngieCustomersService } from '@services/angie-customers/angie-customers.service';
import { ImportService } from '@services/imports/import.service';

@Component({
    selector: 'app-angie-customer-detail',
    templateUrl: './angie-customer-detail.component.html',
    styleUrls: ['./angie-customer-detail.component.scss'],
    providers: [AngieCustomersService, ImportService],
    standalone: false
})
export class AngieCustomerDetailComponent implements OnInit {

  public title = 'Angie Customer: ';
  public customer: Models.AngieCustomer;

  public assignedImports: any;
  public dataProviderParams = {};
  public dataTableColumns = [
    { prop: 'title' }
  ];

  constructor(private angieCustomersService: AngieCustomersService, public importService: ImportService, private activatedRoute: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.angieCustomersService.get(this.activatedRoute.snapshot.params['id']).then(customer => {
      this.customer = customer;
      this.importService.find(0, 1000, { _id: { $in: this.customer.importIds } }).then(result => {
        this.assignedImports = result.data;
      });
    });
  }

  public onDetail(event) {
    this.router.navigate(['imports', event.row._id]);
  }

}
